<template>
<v-flex mb-5 align-self-start>

    <v-layout px-3 my-5 align-center>
        <h1 class="text-xs-left display-2 my-2">System Notifications</h1>
        <v-spacer></v-spacer>
        <v-btn class="green white--text" @click="initCreate = true" disabled>Create Notification</v-btn>
    </v-layout>

    <v-dialog v-model="initCreate" max-width="700px">
        <v-card>
            <v-card-title class="title">Add Notification</v-card-title>
            <v-card-text>
                <create-notification-form :active="initCreate" @close="initCreate = false">
                </create-notification-form>
            </v-card-text>
        </v-card>
    </v-dialog>

    <notifications-data-table></notifications-data-table>

</v-flex>
</template>

<script>
import DataTable from './DataTable'
import CreateForm from './CreateForm'

export default {
    components: {
        NotificationsDataTable: DataTable,
        CreateNotificationForm: CreateForm
    },
    data() {
        return {
            initCreate: false
        }
    },
    created() {
        this.$store.dispatch('getSystemNotifications')
    }
}
</script>
